import { selector } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { type DogUseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/pet';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const getDogUseListSelector = selector<DogUseDTO[]>({
    key: 'getDogUseListSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);

        return await OnlineSalesUnauthenticated.getDogUseList(jobNumber, sessionId, !isLoggedOn);
    }
});
